import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const IconColumn = styled.div`
  flex: 0 0 30px;
  text-align: center;
  line-height: 16px;
`

export const MainColumn = styled.div`
  flex: 1 1 auto;
  flex-direction: column;
  max-width: 100%;
`

export const MainHeader = styled.div`
  display: flex;
  flex-direction: row;
`

export const HeaderTitles = styled.div`
  flex: 1 1 auto;
`

export const HeaderDate = styled.div`
  flex: 0 0 auto;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  margin: 0 0 0.5em 1em;
  text-transform: uppercase;
  white-space: nowrap;
  ${({ theme }) => theme.articlesWidget.itemDate}
`

export const Header = styled.h2`
  font-size: 10px;
  font-weight: bold;
  line-height: 16px;
  letter-spacing: 2px;
  margin: 0 0 0.5em;
  text-transform: uppercase;
`

export const Title = styled.div`
  margin: 0 0 0.25em;
  line-height: 16px;
  font-weight: bold;
  
  a {
    text-decoration: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.mainTextColor};

    &:hover {
      text-decoration: underline;
    }
  }
`

export const Category = styled.div`
  background-color: #49515D;
  font-weight: bold;
  border-radius: 4px;
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 8px;
  margin-bottom: 4px;
`

export const Content = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`

function ArticlesWidgetItem({
  category,
  children,
  className,
  date,
  header,
  icon,
  title,
}) {
  return (
    <div className={className}>
      {icon && <IconColumn>{icon}</IconColumn>}

      <MainColumn>
        {(date || category || header || title) && (
          <MainHeader>
            <HeaderTitles>
              {header && <Header>{header}</Header>}
              {title && <Title>{title}</Title>}
              {category && <Category>{category}</Category>}
            </HeaderTitles>
            {date && <HeaderDate>{date}</HeaderDate>}
          </MainHeader>
        )}
        <Content>
          {children}
        </Content>
      </MainColumn>
    </div>
  )
}

ArticlesWidgetItem.propTypes = {
  category: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  date: PropTypes.node,
  header: PropTypes.node,
  icon: PropTypes.node,
  title: PropTypes.node,
}

export default styled(ArticlesWidgetItem)`
  border-width: 1px 0 0 0;
  border-style: solid;
  padding: 0.75em 0;
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.articlesWidget.item}
`
